// Where a preview note is pinned (#1210, owner 2026-11-03: « she can't leave
// a note on the cover, fix the 3D preview »).
//
// `preview_notes.page_number` is the number printed on the page the customer
// tapped (≥ 1). The covers carry no number, so they take the two values no
// interior page can have:  0 = front cover, -1 = back cover.
// Mirror of worker/src/lib/coverNote.ts — keep the two values in step.
//
// The blank inside-cover sheets are preview-only (they are not in the PDF),
// so they take no note: null.

export const COVER_FRONT_PAGE = 0;
export const COVER_BACK_PAGE = -1;

export type PreviewSheetKind = 'cover-front' | 'inside-cover' | 'page' | 'cover-back';

/** The page_number a tap on this sheet pins its note to, or null (no note). */
export function notePageFor(kind: PreviewSheetKind, n: number): number | null {
  if (kind === 'cover-front') return COVER_FRONT_PAGE;
  if (kind === 'cover-back') return COVER_BACK_PAGE;
  if (kind === 'page') return n;
  return null;
}

export function isCoverNotePage(page: number | null | undefined): boolean {
  return page === COVER_FRONT_PAGE || page === COVER_BACK_PAGE;
}

/** « Couverture » / « Dos de l’album » / « Page N » — sheet title and toast. */
export function notePlaceLabel(page: number): string {
  if (page === COVER_FRONT_PAGE) return 'Couverture';
  if (page === COVER_BACK_PAGE) return 'Dos de l’album';
  return `Page ${page}`;
}
